export default __webpack_public_path__ + "static/media/il.f3773c1d.svg";